// Entity
import { PERSISTED_STORES_TABLES_CONFIG } from "../stores/IPersistedStoreTablesMap";
/**
 * Upsert a versioned baseline into a table
 * @param table The table to upsert the baseline into
 * @param id Id of the entity
 * @param newBaseline New baseline to upsert
 */ export function upsertVersionedBaseline(table, id, newBaseline) {
    const current = table.get(id);
    if (!current) {
        table.add(id, newBaseline);
        return true;
    } else if (current.baseline.itemVersion < newBaseline.itemVersion) {
        current.updateBaseline(newBaseline);
        return true;
    }
    return false;
}
/**
 * Helper method to check if a store type is persisted using the canonical persistence configuration
 */ export function isPersistedStoreType(store) {
    return store in PERSISTED_STORES_TABLES_CONFIG;
}
/**
 * Check if a store is enabled for data persistence and persistent storage is available
 * @param configProvider The config provider to check
 * @param persistentStorage The persistent storage to check
 */ export function isPersistedStorageEnabled(configProvider, persistentStorage) {
    return configProvider().flights.EnableTasksDataPersistence && persistentStorage !== null;
}
/**
 * Utility method to filter persisted tables from the list of all tables for the store
 * @param store store
 * @param allStoreTables all tables in the store including the items table, item status tables and collection status table
 * @returns Filtered record containing only the tables configured for persistence for the given store
 */ export function filterPersistedTablesForStore(store, allStoreTables) {
    const configTableNames = PERSISTED_STORES_TABLES_CONFIG[store];
    if (!configTableNames) {
        return allStoreTables;
    }
    return Object.fromEntries(configTableNames.filter((tableName)=>tableName in allStoreTables).map((tableName)=>[
            tableName,
            allStoreTables[tableName]
        ]));
}
